import { render, staticRenderFns } from "./roomEmpty.vue?vue&type=template&id=285a2c2e&scoped=true&"
import script from "./roomEmpty.vue?vue&type=script&lang=js&"
export * from "./roomEmpty.vue?vue&type=script&lang=js&"
import style0 from "./roomEmpty.vue?vue&type=style&index=0&id=285a2c2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a2c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
